import React from 'react';
import styles from './TableContent.module.scss';
import PropTypes from 'prop-types';
import { Table, } from 'antd';
import { XPagination, } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';
import { FormOutlined } from '@ant-design/icons';

class ContractTable extends React.PureComponent {
    columns = () => [
        {
            title: '协议名称',
            dataIndex: 'contractName',
            key: 'contractName',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => this.contractRender(text, record)
        },
        {
            title: '协议编号',
            dataIndex: 'contractCode',
            key: 'contractCode',
            width: '15%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '数量(份)',
            dataIndex: 'versionCount',
            key: 'versionCount',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '10%',
            render: (id, record) => this.tableAction(id, record)
        }
    ];

    //操作
    tableAction = (id, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(record.contractCode, 'ment', record)}>管理</div>
            </div >
        );
    };

    // 解析表格数据
    _takeDataSource = (data = []) => {
        // 解析表格数据，使符合columns格式要求
        return data.map(item => {
            return item;
        });
    }

    //协议名称
    contractRender = (text, record) => {
        const { tableAction } = this.props;
        return (
            <div className={styles.sort_box} onClick={() => tableAction(record, 'name')}>
                {tooltip(text)}
                <div className={styles.icon}> <FormOutlined /></div>
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { dataList, pageSize, pageNum, resultTotal } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.contractCode}
                    columns={this.columns()}
                    dataSource={this._takeDataSource(dataList)}
                    pagination={false}
                    scroll={{ x: 'max-content', y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

ContractTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default ContractTable;